/* eslint-disable react-hooks/exhaustive-deps */
import { loadByContentList } from 'providers/actions/loadByCid'
import { ServerSidePropsContext } from 'providers/ServerSideProps'
import React, { createContext, useContext, useEffect, useState } from 'react'
// import { enviarPageView } from 'hooks/useGCJAnalytics'
import { useRouter } from 'next/router'
import { getSessionDataFromCookie } from 'providers/Session/utils'

export type PagesContextType = {
  articles: Array<any>;
  domain: string;
  navigation: any;
  pageData: Object;
  pageList: Object;
  pageListData: Array<Object>;
  pageLoading: boolean;
  pageType: {
    type: string;
    departmentSlug: string;
  };
  siteData: any;
  siteExtId: string;
  siteList: any;
  siteName: string;
}

export const PagesContext = createContext<PagesContextType>({} as PagesContextType)

const PagesProvider = ({ children }) => {

  const router = useRouter()
  const serverSideContext = useContext(ServerSidePropsContext)
  const [articles, setArticles] = useState<Array<Object>>([])
  const [domain, setDomain] = useState<string>(serverSideContext.domain)
  const [pageData, setPageData] = useState<Object>({})
  const [pageList, setPageList] = useState<Object>({})
  const [pageListData, setPageListData] = useState<Array<Object>>([])
  const [pageLoading, setPageLoading] = useState<boolean>(false)
  const [pageType, setPageType] = useState<PagesContextType['pageType']>({ type: '', departmentSlug: '' })
  const [navigation, setNavigation] = useState(serverSideContext.navigation)
  const [siteData, setSiteData] = useState<Object>({})
  const [siteExtId, setSiteExtId] = useState<string>('')
  const [siteList, setSiteList] = useState<Object>({})
  const [siteName, setSiteName] = useState<string>('')
  const sessionData = getSessionDataFromCookie();

  const loadArticle = () => {
    setPageLoading(true)

    loadByContentList(serverSideContext.pageSlots,sessionData)
      .then((response) => {
        setPageType(serverSideContext.pageType)
        setNavigation(serverSideContext.navigation)
        setArticles(serverSideContext.article)
        setPageData(serverSideContext.page)
        setPageList(serverSideContext.pageSlots)
        setPageListData(response)
        setSiteData(serverSideContext.site)
        setSiteExtId(serverSideContext.site.extid)
        setSiteList(serverSideContext.siteSlots)
        setSiteName(serverSideContext.site.name)
        setPageLoading(false)
      })
      .catch((e) => {
        console.log('[Fetch error :: loadArticle]', e)
        setPageLoading(false)
      })
  }

  const loadDepartment = () => {
    setPageLoading(true)
    loadByContentList(serverSideContext.pageSlots,sessionData)
      .then((response) => {
        setPageType(serverSideContext.pageType)
        setNavigation(serverSideContext.navigation)
        setArticles([])
        setPageData(serverSideContext.page)
        setPageList(serverSideContext.pageSlots)
        setPageListData(response)
        setSiteData(serverSideContext.site)
        setSiteExtId(serverSideContext.site.extid)
        setSiteList(serverSideContext.siteSlots)
        setSiteName(serverSideContext.site.name)
        setPageLoading(false)
      })
      .catch((e) => {
        console.log('[Fetch error :: loadDepartment]', e)
        setPageLoading(false)
      })
  }

  const loadHome = () => {
    setPageLoading(true)
    loadByContentList(serverSideContext.siteSlots,sessionData)
      .then((response) => {
        setPageType(serverSideContext.pageType)
        setNavigation(serverSideContext.navigation)
        setArticles([])
        setPageData(serverSideContext.page)
        setPageList(serverSideContext.siteSlots)
        setPageListData(response)
        setSiteData(serverSideContext.site)
        setSiteExtId(serverSideContext.site.extid)
        setSiteList(serverSideContext.siteSlots)
        setSiteName(serverSideContext.site.name)
        setPageLoading(false)
      })
      .catch((e) => {
        console.log('[Fetch error :: loadHome]', e)
        setPageLoading(false)
      })
  }

  useEffect(() => {
    if (serverSideContext.pageType.type === 'article') {
      loadArticle()
    }
    else if (serverSideContext.pageType.type === 'department') {
      loadDepartment()
      //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
      // quando confirmado a migração, remover.
      // enviarPageView({ referer: window?.location?.href, contentId: serverSideContext.page.id.replace('policy:', '') });
    }
    else if (serverSideContext.pageType.type === 'home') {
      loadHome()
      //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
      // quando confirmado a migração, remover.
      //  enviarPageView({ referer: window?.location?.href, contentId: serverSideContext.site?.id.replace('policy:', '') });
    }
  }, [router.asPath])

  return (
    <PagesContext.Provider
      value={{
        articles,
        domain,
        navigation,
        pageData,
        pageList,
        pageListData,
        pageLoading,
        pageType,
        siteData,
        siteExtId,
        siteList,
        siteName
      }}
    >
      {children}
    </PagesContext.Provider>
  )
}

export default PagesProvider
